import {createContext} from 'react'

export type Analytics<T extends object> = {
  analyticsData: T
}

export const AnalyticsDataContext = createContext<Analytics<any> | undefined>(undefined)
